import React, { Component } from "react";
import TableC from "../../../basicElement/TableC";
import API_URL from "../../../../common/url";
import $ from "../../../../common/AjaxRequest";
import { Icon, Tooltip } from "antd";
import format from "../../../shared/format";

export default class AnnualThroughput extends Component {
    state = {
        annualOutputData: [],
        nonBindAnnualOutputData: [],
        type: "view",
        params: {},
    };

    componentDidMount() {
        const { evaluateRecordId } = this.props;
        this.setState(
            {
                params: { evaluateRecordId },
            },
            this.queryServeFeeType
        );
    }

    componentWillReceiveProps(nextProps) {
        const { evaluateRecordId } = nextProps;
        this.setState(  
            {
                params: { evaluateRecordId },
            },
            this.queryServeFeeType
        );
    }

    loadData = (evaluateRecordId, serveFeeType) => {
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryEvaluateVisitFeeData,
            data: { evaluateRecordId, serveFeeType },
            dataType: "json",
            doneResult: (res) => {
                const { evaluateVisitQuotation, evaluateVisitNonBindQuotation } = res;
                this.setState({
                    annualOutputData: evaluateVisitQuotation ? [
                        {
                            ...evaluateVisitQuotation
                        },
                    ] : [],
                    nonBindAnnualOutputData: evaluateVisitNonBindQuotation ? [
                        {
                            ...evaluateVisitNonBindQuotation
                        },
                    ] : [],
                })
            },
        };
        $.sendRequest(options);
    };

    queryServeFeeType = () => {
        const { params: {evaluateRecordId} } = this.state
        if(!evaluateRecordId) return
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryServeFeeType,
            data: { evaluateRecordId },
            dataType: "json",
            doneResult: (res) => {
                const { serveFeeType } = res;
                this.setState({
                    serveFeeType,
                },() => {
                    this.loadData(evaluateRecordId, serveFeeType);
                })
            },
        };
        $.sendRequest(options);
    }

    getColumns = (isBindAndNonBind = false) => {
        const columns = [
            {
                title: "客户名称",
                key: "sponsorName",
                dataIndex: "sponsorName",
                width: 120,
            }, {
                title: "领域/疾病",
                key: "diseaseName",
                dataIndex: "diseaseName",
                width: 120,
            }, {
                title: "中心数",
                key: "startSiteNum",
                dataIndex: "startSiteNum",
                width: 100,
            }, {
                title: "计划入组例数",
                key: "randomCaseNum",
                dataIndex: "randomCaseNum",
                width: 100,
            }, {
                title: "标准访视数",
                key: "standardVisitAmount",
                dataIndex: "standardVisitAmount",
                width: 100,
            }, {
                title: <span>标准工时/调整 FTE
                    <Tooltip title={`${isBindAndNonBind ? '（评估工时（小时）合计值-非盲CRC服务评估工时（小时）-非盲PM服务评估工时（小时））/160' : '评估工时（小时）合计值/160'}`}>
                        <a style={{ float: 'right' }}><Icon type="info-circle" /></a>
                    </Tooltip></span>,
                key: "pmEstimatedFte",
                dataIndex: "pmEstimatedFte",
                width: 140,
            }, {
                title: "入组期",
                key: "joinGroupPeriod",
                dataIndex: "joinGroupPeriod",
                width: 100,
            },{
                title: "治疗期",
                key: "dtreatmentPeriod",
                dataIndex: "treatmentPeriod",
                width: 100,
            }, {
                title: "随访期",
                key: "followUpPeriod",
                dataIndex: "followUpPeriod",
                width: 100,
            }, {
                title: "生存随访期",
                key: "survivalFollowUpPeriod",
                dataIndex: "survivalFollowUpPeriod",
                width: 100,
            }, {
                title: "项目周期（月）",
                key: "investigationCycleMonthCount",
                dataIndex: "investigationCycleMonthCount",
                width: 120,
            }, {
                title: "每例病人访视次数",
                key: "singlePatientTotalCount",
                dataIndex: "singlePatientTotalCount",
                width: 120,
            }, {
                title: "此项目入组速率预估（pts/site/m）",
                key: "smoPredicatedAverageInGroupRate",
                dataIndex: "smoPredicatedAverageInGroupRate",
                width: 150,
            }, {
                title: "客户参数预测平均入组速率预测（pts/site/m）",
                key: "customerPredictedAverageInGroupRate",
                dataIndex: "customerPredictedAverageInGroupRate",
                width: 150,
            }, {
                title: `${isBindAndNonBind ? '盲态服务' : ''}总价金额(不含税)/人民币`,
                key: "evaluateTotalPrice",
                dataIndex: "evaluateTotalPrice",
                width: 120,
                render: text => (text || text == 0) ? format('money', text) : ''
            }, {
                title: `${isBindAndNonBind ? '盲态服务' : ''}单例价格金额(不含税)/人民币`,
                key: "evaluateUnitPrice",
                dataIndex: "evaluateUnitPrice",
                width: 120,
                render: text => (text || text == 0) ? format('money', text) : ''
            }, {
                title: <span>项目年产出（不含税）/人民币
                    <Tooltip title={isBindAndNonBind ? <span>
                        <div>如果“随访期”≤24个月，那么项目年产出=盲态服务总价金额（不含税）/((客户项目参数下入组期+治疗期+随访期)/12)/客户项目参数下“启动中心数”</div>
                        <div>如果“随访期”＞24个月，那么项目年产出=盲态服务总价金额（不含税）/((客户项目参数下入组期+治疗期)/12)/客户项目参数下“启动中心数”</div>
                    </span> : <span>
                        <div>如果“随访期”≤24个月，那么项目年产出=总价金额（不含税）/((客户项目参数下入组期+治疗期+随访期)/12)/客户项目参数下“启动中心数””</div>
                        <div>如果“随访期”＞24个月，那么项目年产出=总价金额（不含税）/((客户项目参数下入组期+治疗期)/12)/客户项目参数下“启动中心数”</div>
                    </span>}>
                    <a style={{ float: 'right' }}><Icon type="info-circle" /></a>
                </Tooltip></span>,
                key: "investigationYearOutput",
                dataIndex: "investigationYearOutput",
                width: 160,
                render: text => (text || text == 0) ? format('money', text) : ''
            }];
        return columns;
    };

    getNonBindColumns = (isBindAndNonBind = false) => {
        const columns = [
            {
                title: "客户名称",
                key: "sponsorName",
                dataIndex: "sponsorName",
                width: 120,
            }, {
                title: "领域/疾病",
                key: "diseaseName",
                dataIndex: "diseaseName",
                width: 120,
            }, {
                title: "中心数",
                key: "startSiteNum",
                dataIndex: "startSiteNum",
                width: 100,
            }, {
                title: "计划入组例数",
                key: "randomCaseNum",
                dataIndex: "randomCaseNum",
                width: 100,
            }, {
                title: "每例病人访视次数",
                key: "patientVisitNum",
                dataIndex: "patientVisitNum",
                width: 100,
            }, {
                title: "每例病人治疗（用药）次数",
                title: <span>每例病人治疗（用药）次数
                <Tooltip title={<div>
                    1）当访视方案数=1，取该方案下定义为“治疗（用药）”的访视次数合计；<br/>
                    2）当访视方案数≥2，该字段内容值计算要求如下：<br/>
                    第一步：计算出各个访视方案下定义为“治疗（用药）”访视次数合计*该访视方案的“计划（随机）入组数”的值；<br/>
                    第二步：所有访视方案下，对第一步计算结果求和；<br/>
                    第三步：第二步计算结果/客户项目参数下“随机病例数”。<br/>
                </div>}>
                    <a style={{ float: 'right' }}><Icon type="info-circle" /></a>
                </Tooltip></span>,
                key: "patientTreatmentNum",
                dataIndex: "patientTreatmentNum",
                width: 100,
            }, {
                // title: '每次治疗（用药）折合价格',
                title: <span>每次治疗（用药）折合价格
                <Tooltip title={`非盲CRC服务总价(不含税)/计划入组例数/每患者治疗（用药）次数`}>
                    <a style={{ float: 'right' }}><Icon type="info-circle" /></a>
                </Tooltip></span>,
                key: "treatmentPrice",
                dataIndex: "treatmentPrice",
                width: 140,
            }, {
                title: <span>非盲CRC评估总FTE
                <Tooltip title={`“非盲CRC月均FTE”*“非盲服务中心数”*（“入组期”月份数+“治疗期”月份数）`}>
                    <a style={{ float: 'right' }}><Icon type="info-circle" /></a>
                </Tooltip></span>,
                key: "nonBindCrcTotalFte",
                dataIndex: "nonBindCrcTotalFte",
                width: 100,
            }, {
                title: <span>每例病人非盲工作评估FTE
                <Tooltip title={`非盲CRC评估总FTE/计划入组数`}>
                    <a style={{ float: 'right' }}><Icon type="info-circle" /></a>
                </Tooltip></span>,
                key: "patientNonBindCrcFte",
                dataIndex: "patientNonBindCrcFte",
                width: 100,
            }, {
                title: <span>每次治疗（用药）评估FTE
                <Tooltip title={`非盲CRC评估总FTE/计划入组例数/每患者治疗（用药）次数`}>
                    <a style={{ float: 'right' }}><Icon type="info-circle" /></a>
                </Tooltip></span>,
                key: "treatmentFte",
                dataIndex: "treatmentFte",
                width: 100,
            }, {
                title: "非盲CRC服务总价金额（不含税）/人民币",
                key: "nonBindCrcTotalPrice",
                dataIndex: "nonBindCrcTotalPrice",
                width: 100,
                render: text => (text || text == 0) ? format('money', text) : ''
            }, {
                title: "非盲PM服务总价金额（不含税）/人民币",
                key: "nonBindPmTotalPrice",
                dataIndex: "nonBindPmTotalPrice",
                width: 100,
                render: text => (text || text == 0) ? format('money', text) : ''
            }, {
                title: `${isBindAndNonBind ? '非盲服务' : ''}总价金额（不含税）/人民币`,
                key: "evaluateTotalPrice",
                dataIndex: "evaluateTotalPrice",
                width: 100,
                render: text => (text || text == 0) ? format('money', text) : ''
            }, {
                title: `${isBindAndNonBind ? '非盲服务' : ''}单例价格金额（不含税）/人民币`,
                key: "evaluateUnitPrice",
                dataIndex: "evaluateUnitPrice",
                width: 100,
                render: text => (text || text == 0) ? format('money', text) : ''
            }, {
                title: <span>{`项目${isBindAndNonBind ? '非盲服务' : ''}年产出（不含税）/人民币`}
                <Tooltip title={`${isBindAndNonBind ? '非盲服务总价金额（不含税）/((客户项目参数下入组期+治疗期)/12)/客户项目参数下“启动中心数”' : '总价金额（不含税）/((客户项目参数下入组期+治疗期)/12)/客户项目参数下“启动中心数”'}`}>
                    <a style={{ float: 'right' }}><Icon type="info-circle" /></a>
                </Tooltip></span>,
                key: "investigationYearOutput",
                dataIndex: "investigationYearOutput",
                width: 100,
                render: text => (text || text == 0) ? format('money', text) : ''
            }];
        return columns;
    };

    render() {
        const { annualOutputData, nonBindAnnualOutputData, serveFeeType } = this.state;
        const { showButn = true } = this.props;
        const isBind = serveFeeType === "BIND";  //项目包含盲态服务
        const isBindAndNonBind = serveFeeType === "NON_BIND,BIND";  //项目包含盲态服务和非盲服务
        return (
            <div>
                <div style={{
                    minHeight: showButn ? 570 : 0
                }}>
                    {
                        isBindAndNonBind ? <div>
                            <div style={{ marginBottom: 10 }}>
                            <div style={{ marginBottom: 10 }}>盲态服务年产出</div>
                                <TableC
                                    data={annualOutputData}
                                    columns={this.getColumns(isBindAndNonBind)}
                                    pagination={false}
                                />
                            </div>
                            <div sstyle={{ marginBottom: 10 }}>
                            <div style={{ marginBottom: 10 }}>非盲服务年产出</div>
                                <TableC
                                    data={nonBindAnnualOutputData}
                                    columns={this.getNonBindColumns(isBindAndNonBind)}
                                    pagination={false}
                                />
                            </div>
                        </div> 
                        :
                        <TableC
                            data={isBind ? annualOutputData : nonBindAnnualOutputData}
                            columns={ 
                                isBind ? 
                                this.getColumns() 
                                : 
                                this.getNonBindColumns()
                            }
                            pagination={false}
                        />
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/AnnualThroughput.js